// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"b65c61a1","787":"a45eee56"}[chunkId] + ".chunk.js";
};